import { Tabs, TabsProps } from "antd";
import CompanyInvitationsV2 from "../invitation/CompanyInvitationsV2";
import CustomLabel from "../share/customLabel";
import { ColorPalette } from "../share/color/colorPalette";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Collaborators from "../Company/Collaborators";

const CollabratingCompany = () => {
  const navigate = useNavigate();
  const path = useLocation();
  const [getTab, setTab] = useState("2");
  useEffect(() => {
    const searchParams = new URLSearchParams(path.search);
    const tab = searchParams.get("tab");
    if (tab !== undefined && tab !== null) {
      setTab(tab);
    }
  }, [path]);
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "فروشگاه های همکار",
      children: <Collaborators />,
    },
    {
      key: "2",
      label: "دعوتنامه فروشگاهی",
      children: <CompanyInvitationsV2 />,
    },
  ];
  const onChange = (key: string) => {
    navigate(`/CollabratingCompanies?tab=${key}`);
  };

  return (
    <>
      <Tabs
        style={{ fontFamily: "YekanBakhVF" }}
        tabBarStyle={{ marginBottom: 1 }} // Reduces spacing below tab headers
        defaultActiveKey="1"
        items={items}
        activeKey={getTab}
        onChange={onChange}
      />
    </>
  );
};
export default CollabratingCompany;
